import React, { forwardRef, useImperativeHandle, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

type BottomSheetWrapperProps = {
  children: React.ReactNode;
  className?: string;
  overlayClassName?: string;
  onOverlayClick?: () => void;
};

export type BottomSheetWrapperRef = {
  show: () => void;
  hide: () => void;
};

const BottomSheetWrapper = forwardRef<
  BottomSheetWrapperRef,
  BottomSheetWrapperProps
>(({ children, className, overlayClassName, onOverlayClick }, ref) => {
  const [isVisible, setIsVisible] = useState(false);

  useImperativeHandle(ref, () => ({
    show: () => setIsVisible(true),
    hide: () => setIsVisible(false),
  }));

  return (
    <AnimatePresence>
      {isVisible && (
        <div className="fixed inset-0 z-50 flex items-end justify-center">
          {/* Overlay */}
          <div
            className={`fixed inset-0 bg-black bg-opacity-50 transition-opacity ${
              overlayClassName || ""
            }`}
            onClick={onOverlayClick || (() => setIsVisible(false))}
          />

          {/* Bottom Sheet */}
          <motion.div
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
            className={`relative w-full max-h-[60vh] rounded-t-2xl bg-white shadow-lg overflow-y-auto ${
              className || ""
            }`}
          >
            {children}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
});

BottomSheetWrapper.displayName = "BottomSheetWrapper";

export default BottomSheetWrapper;
